import axios from 'axios';

const PortalSchoolSessionTerm = {
    namespaced: true,
    actions: {
        GetPortalSchoolSessionById({ rootState }, PortalSchoolSessionId) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalSchoolSessionTerm/GetPortalSchoolSessionById?PortalSchoolSessionId=${PortalSchoolSessionId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        PortalGetSessionInAlumni({ rootState }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalSchoolSessionTerm/PortalGetSessionInAlumni`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetPortalSchoolSessions({ rootState },{SearchValue,PageNumber,PageSize}) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalSchoolSessionTerm/GetPortalSchoolSessions?SearchValue=${SearchValue}&PageNumber=${PageNumber}&PageSize=${PageSize}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetPortalRegisteredTerm({ rootState },{SearchValue,PageNumber,PageSize}) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalSchoolSessionTerm/GetPortalRegisteredTerm?SearchValue=${SearchValue}&PageNumber=${PageNumber}&PageSize=${PageSize}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

    }
}

export default PortalSchoolSessionTerm